module.exports = __webpack_public_path__ + "static/media/Shiinotic_gaussian2.16232b74.png";